const kategoria = { t: 'Kategoria', name: 'podkategoria', hint: { url: '/tool_subcategory', deps: ['kategoria'] }}
export default kategoria